import ClearIcon from '@mui/icons-material/Clear';
import { Box, Button, Card, ListItem, useTheme } from '@mui/material';
import { FC } from 'react';
import { Detail } from '@/types/detail';
import { ConfigurationMultiple } from '@/types/metadata/metadata';
import { multipleUtil } from '@/util/validation/multiple';
import ConfirmPopover from '@/components/common/ConfirmPopover';
import List from '@/components/common/List';
import ParamRenderer, { ParamProps } from './ParamRenderer';

const ParamMultiple: FC<ParamProps> = (props) => {
  const theme = useTheme();
  const configuration = props.configuration as ConfigurationMultiple;

  const initialValue = multipleUtil().getValue(props.configuration, props.initialValue);

  const removeEntry = (indexToRemove: number, values: Detail[]) => {
    const newInitialValue = values.filter((_, index) => index !== indexToRemove);
    props.onChange([configuration.value, newInitialValue]);
  };

  return (
    <Card
      variant='outlined'
      sx={{
        flexGrow: 1,
        m: 0,
        p: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        ...(props.errors?.length && { borderColor: theme.palette.error.main })
      }}
    >
      <List
        subheader={props.configuration.label + (props.configuration.required ? ' *' : '')}
        sx={{ width: '100%', display: 'grid', gap: 1 }}
      >
        {configuration.sections.length > 0 &&
          initialValue &&
          initialValue.map((initValPart, index) => (
            <Box key={`multi-section-${index}`}>
              <ListItem sx={{ p: 0.5 }}>
                <Card variant='outlined' sx={{ p: 1, width: '100%' }}>
                  <ParamRenderer
                    nodeId={props.nodeId}
                    parentId={props.parentId}
                    configuration={configuration.sections[0]}
                    initialValue={initValPart}
                    onChange={(...args) => {
                      const newDetails = { ...(initValPart as Detail) };
                      args.forEach(([configValue, newValue]) => {
                        newDetails[configValue] = newValue;
                      });
                      initialValue[index] = newDetails as any;
                      props.onChange([configuration.value, initialValue]);
                    }}
                  />
                </Card>
                <ConfirmPopover
                  onConfirm={() => {
                    removeEntry(index, initialValue);
                  }}
                  icon={<ClearIcon />}
                  text='Delete this section?'
                />
              </ListItem>
            </Box>
          ))}
      </List>
      <Button
        variant='contained'
        color='primary'
        onClick={() => {
          //Create blank entry for initialValue
          const newInitialValue = [...(initialValue || []), {}];
          props.onChange([configuration.value, newInitialValue]);
        }}
      >
        New
      </Button>
    </Card>
  );
};

export default ParamMultiple;
